import axiosInstance from "../utils/axios";

export const GetProgramsList = async (data) => {
  return await axiosInstance().post(`/getProgramsLists`, data);
};

export const GetProgramsListCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post(`/getProgramsLists`, values, {
    cancelToken: cancelToken
  });
};

export const GetProgramsDetailsCancelToken = async (id, cancelToken) => {
  return await axiosInstance().get(`getProgramsDetail?id=${id}`, {cancelToken});
};
export const GetSchoolListCancelToken = async (cancelToken) => {
  return await axiosInstance().get(`/getSchoolList`, {cancelToken});
};

export const DeleteProgramme = async (id) => {
  return await axiosInstance().get(`deleteProgramme?id=${id}`);
};

export const CreateProgramme = async (data) => {
  return await axiosInstance().post(`createQualification`, data);
};

export const UpdateProgramme = async (data) => {
  return await axiosInstance().post(`editQualification`, data);
};

export const GetProgrammeStudent = async (id) => {
  return await axiosInstance().get(`qualificationStudentList?id=${id}`);
};
export const getVersionDropdownList = async (params) => {
  return await axiosInstance().get(`getVersionDropdownForPrograme`, {params : params});
};

export const GetProgrammeStudentCancelToken = async (id, cancelToken) => {
  return await axiosInstance().get(`qualificationStudentList?id=${id}`, {cancelToken});
};

export const GetProgramsNotificationListCancelToken = async (id, cancelToken) => {
  return await axiosInstance().get(`getProgramsNotificationList`, {params: {intake: id}, cancelToken});
};

export const GetProgramsNotificationDetails = async (id) => {
  return await axiosInstance().get(`getProgramsNotificationDetails?id=${id}`);
};

export const GetProgrammeModules = async (data, id) => {
  return await axiosInstance().get(`getSubjectProgramAssignedOrNotAssignedList?qualification=${id}&type=${data}`);
};

export const GetProgrammeModulesCancelToken = async (data, id, cancelToken) => {
  return await axiosInstance().get(`getSubjectProgramAssignedOrNotAssignedList`, { params:{qualification: id, type: data}, cancelToken: cancelToken });
};

export const AssignSubjectToProgram = async (data) => {
  return await axiosInstance().post(`assignSubjectToProgram`, data);
};

export const DeleteAssignSubjectToProgram = async (data) => {
  return await axiosInstance().post(`deleteAssignSubjectToProgram`, data);
};

export const DeleteProgrameNotification = async (id) => {
  return await axiosInstance().get(`deleteNotifications?id=${id}`);
};

export const GetCommonContent = async (id) => {
  return await axiosInstance().get(`getCommonContent`);
};

export const GetCommonContentCancelToken = async (cancelToken) => {
  return await axiosInstance().get(`/getCommonContent`, {
    cancelToken: cancelToken
  });
};

export const GetNetsuiteProductListCancelToken = async (type, cancelToken) => {
  return await axiosInstance().get(`getNetsuiteProductList?itemtype=${type}`, {cancelToken});
};

export const GetNetsuiteCampusListCancelToken = async (type, cancelToken) => {
  return await axiosInstance().get(`getNetsuiteCampusList?itemtype=${type}`, {cancelToken});
};

export const ExportGrade = async (id) => {
  return await axiosInstance().get(`exportQualificationAssessment?qualification=${id}`);
};

export const UpdateStudentNotification = async (data) => {
  return await axiosInstance().post(`updateStudentNotification`, data);
};

export const PreviewStudentNotification = async (data) => {
  return await axiosInstance().post(`previewStudentNotification`, data);
};
export const GetAllLecturers = async () => {
  return await axiosInstance().get(`getAllLecturerList`);
}

export const GetCommonContentReReg = async () => {
  return await axiosInstance().get(`/getCommonContent?api_section=re_registration`);
};

export const GetProgramsListFilter = async (id) => {
  return await axiosInstance().get(`getProgramsList_filter`);
};

export const GetProgramsListFilterCancelToken = async (cancelToken) => {
  return await axiosInstance().get(`/getProgramsList_filter`, {
    cancelToken: cancelToken
  });
};


export const GetSubjectProgramAssignedOrNotAssignedListFilter = async (data, id) => {
  return await axiosInstance().get(`getSubjectProgramAssignedOrNotAssignedListFilter?qualification=${id}&type=${data}`);
};

export const getProgramAuditTrial = async (data) => {
  return await axiosInstance().post(`getProgramAuditTrial`, data);
};

export const GetProgramAuditTrialCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post(`/getProgramAuditTrial`, values, {
    cancelToken: cancelToken
  });
};

export const GetGrademixAuditTrialCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post(`/getGrademixAuditTrial`, values, {
    cancelToken: cancelToken
  });
};

export const getProgramAuditTrialDropdown = async (params) => {
  return await axiosInstance().get(`getProgramAuditTrialDropdown`, { params });
};

export const GetProgramAuditTrialDropdownCancelToken = async (params,cancelToken) => {
  return await axiosInstance().get(`/getProgramAuditTrialDropdown`, { params, cancelToken: cancelToken });
};

export const GetGrademixAuditTrialDropdownCancelToken = async (params,cancelToken) => {
  return await axiosInstance().get(`/getGrademixAuditTrialDropdown`, { params, cancelToken: cancelToken });
};

export const getProgrammeModulesGradeStudentList = async(values, cancelToken)=>{
 return await axiosInstance().post(`/getProgrammeModulesGradeStudentList`, values, {
    cancelToken: cancelToken
  });
}

export const getProgramGradebookModuleList = async (params,cancelToken) => {
  return await axiosInstance().get(`/getProgramGradebookModuleList`, { params, cancelToken: cancelToken });
};

export const getGradebookOriginIntakes = async (params) => {
  return await axiosInstance().get(`/getGradebookOriginIntakes`, { params });
};

export const getGradebookProgrammeCode = async (params) => {
  return await axiosInstance().get(`/getGradebookProgrammeCode`, { params });
};

export const getGradebookExportData = async (params) => {
  return await axiosInstance().post(`/getGradebookExportData`, params);
};

export const exportGradebookExcel = async (params) => {
  return await axiosInstance().post(`/exportGradebookExcel`, params, {
    responseType: 'blob'
  });
};

export const startBulkPmcSor = async (data) => {
  return await axiosInstance().post(`/generatePmcSor`, data);
};

export const getBulkSorJobStatus = async (id) => {
  return await axiosInstance().get(`/getBulkSorJobStatus/${id}`);
};